'use client'
import React from 'react'

interface LogoProps {
  src: string
  width: number
  height: number
  alt: string
  className?: string
  loading?: 'lazy' | 'eager'
  priority?: 'auto' | 'high' | 'low'
}

export const Logo: React.FC<LogoProps> = ({
  src,
  width,
  height,
  alt,
  className,
  loading = 'lazy',
  priority = 'low',
}) => (
  <img
    src={src}
    width={width}
    height={height}
    alt={alt}
    loading={loading}
    fetchPriority={priority}
    decoding="async"
    className={`max-w-[9.375rem] w-full object-contain ${className || ''}`}
  />
)
